module.exports = __webpack_public_path__ + "img/icon_close_red_wghn.da8317df.svg";